/// <reference path="../_references.ts"/>

module App.Administrative.Tags {
	import ServiceRequest = App.Appointments.ServiceRequest;
	import Customer = App.Appointments.Customer;

	export class TagsService {
		constructor(
			private $http: ng.IHttpService,
			private Constants: IConstants
		) {

		}

		fetchCustomerTags(): ng.IHttpPromise<Tag[]> {
			return this.$http.get(`${this.Constants.apiUrl}customertag`);
		}

		fetchTagColors(): ng.IHttpPromise<TagColor[]> {
			return this.$http.get(`${this.Constants.apiUrl}tagcolor`);
		}

		createCustomerTag(data: Tag): ng.IHttpPromise<Tag> {
			return this.$http.post(`${this.Constants.apiUrl}customertag`, data);
		}

		updateCustomerTag(data: Tag): ng.IHttpPromise<Tag> {
			return this.$http.put(`${this.Constants.apiUrl}customertag/` + data.id, data);
		}

		fetchSRTags(): ng.IHttpPromise<Tag[]> {
			return this.$http.get(`${this.Constants.apiUrl}servicerequesttag`);
		}

		createSRTag(data: Tag): ng.IHttpPromise<Tag> {
			return this.$http.post(`${this.Constants.apiUrl}servicerequesttag`, data);
		}

		updateSRTag(data: Tag): ng.IHttpPromise<Tag> {
			return this.$http.put(`${this.Constants.apiUrl}servicerequesttag/` + data.id, data)
		}

		updateCustomer(customer: Customer): ng.IHttpPromise<Customer> {
			return this.$http.put(this.Constants.apiUrl + `customer/${customer.id}`, customer);
		}

		updateSr(sr: ServiceRequest): ng.IHttpPromise<ServiceRequest> {
			return this.$http.put(this.Constants.apiUrl + `servicerequest/${sr.id}`, sr);
		}

		public static Factory() {
			let instance = ($http: ng.IHttpService, Constants: IConstants) => {
				return new TagsService($http, Constants);
			};

			instance.$inject = ['$http', 'Constants'];

			return instance;
		}
	}
}
